import React from "react";

interface IOwnProps {
  color?: string;
  size?: number;
}

export const GoodToKnowIcon = ({
  // color = "#17132A"
  color = "currentColor",
  size = 24,
}: IOwnProps) => {
  return (
    <svg
      width={size}
      height={size + 1}
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_2227_7851"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="25"
      >
        <path
          d="M7.01533e-09 0.865417L24 0.865417L24 24.8654L0 24.8654L7.01533e-09 0.865417Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_2227_7851)">
        <path
          d="M1.72302 22.4488L1.72302 19.2937C2.77912 19.5444 3.63791 19.7146 4.72443 19.7001C6.4326 19.6776 7.14932 19.3457 9.05849 19.1985C10.5796 19.0813 11.6413 20.2387 11.9193 21.351"
          stroke={color}
          strokeWidth="0.923077"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.9198 21.351C12.1978 20.2387 13.2595 19.0813 14.7806 19.1985C16.6898 19.3457 17.4065 19.6776 19.1146 19.7001C20.2012 19.7146 21.06 19.5444 22.1161 19.2937L22.1161 22.4488"
          stroke={color}
          strokeWidth="0.923077"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.2288 22.4478C15.2288 23.3949 14.4611 24.1625 13.5141 24.1625L10.4681 24.1625C9.52114 24.1625 8.75342 23.3949 8.75342 22.4478"
          stroke={color}
          strokeWidth="1.40625"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M0.689941 22.4495L8.74907 22.4495"
          stroke={color}
          strokeWidth="1.40625"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.2307 22.4495L23.2898 22.4495"
          stroke={color}
          strokeWidth="1.40625"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.6336 6.96851C16.6336 8.01664 16.2867 8.9832 15.7012 9.75992C14.8528 10.8863 14.2847 12.166 14.0611 13.6004L9.91919 13.6004C9.69705 12.1618 9.13169 10.8854 8.28794 9.77351C7.68372 8.97711 7.33028 7.97961 7.34622 6.89867C7.38278 4.39882 9.42372 2.35976 11.9236 2.32508C14.5186 2.28898 16.6336 4.38195 16.6336 6.96851Z"
          stroke={color}
          strokeWidth="0.923077"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.0626 13.5999L14.051 15.1501C14.046 15.849 13.4481 16.4124 12.7124 16.4124L11.2644 16.4124C10.5251 16.4124 9.9259 15.8434 9.9259 15.1412L9.9259 13.5999L14.0626 13.5999Z"
          stroke={color}
          strokeWidth="1.40625"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.9895 13.6004L11.9895 8.82054"
          stroke={color}
          strokeWidth="1.40625"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.5814 6.27515L2.23718 6.27515"
          stroke={color}
          strokeWidth="1.40625"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19.0972 9.78913L21.117 10.979"
          stroke={color}
          strokeWidth="1.40625"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.88698 9.78913L2.86719 10.979"
          stroke={color}
          strokeWidth="1.40625"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19.0999 2.75935L21.1197 1.56943"
          stroke={color}
          strokeWidth="1.40625"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.88698 2.75935L2.86719 1.56943"
          stroke={color}
          strokeWidth="1.40625"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19.4071 6.27515L21.7513 6.27515"
          stroke={color}
          strokeWidth="1.40625"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};
